import { MouseEventHandler, ReactNode } from 'react';

import { css, cx } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

interface Props {
  items: { label: ReactNode; value: string }[];
  onClick: MouseEventHandler<HTMLButtonElement>;
  className?: string;
}

const PriceRateButtons = ({ items, onClick, className }: Props) => {
  return (
    <div className={hstack({ gap: 6 })}>
      {items.map((item) => {
        return (
          <button
            type='button'
            value={item.value}
            key={item.value}
            onClick={onClick}
            className={cx(css(buttonStyle), className)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default PriceRateButtons;

const buttonStyle = css.raw({
  position: 'relative',
  flex: 1,
  h: 32,
  textStyle: 'Text/S/Strong',
  color: 'content.default.level-2',
  bgColor: 'background.default.level-3',
  rounded: 4,
  '&:active': {
    color: 'content.default.level-5',
  },
  '&:not(:disabled)': {
    '&:focus': {
      '&::before': {
        position: 'absolute',
        inset: '-2px',
        content: "''",
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'content.accent.info',
        rounded: 4,
      },
    },
  },
});
